import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

const Dropdown = ({ dropdownData, handleDropdownClick, hidden }) => {
  return (
    <Root hidden={hidden}>
      {dropdownData.map((item, index) => (
        <Wrapper
          key={index}
          onClick={() => handleDropdownClick(item.id, item.name)}
        >
          <p className="uppercase">{item.name}</p>
        </Wrapper>
      ))}
    </Root>
  );
};

Dropdown.propTypes = {
  className: PropTypes.string,
};

export default Dropdown;

const Root = styled.div`

  position: absolute;
  opacity: ${(props) => (props.hidden ? 0 : 1)};
  pointer-events: ${(props) => (props.hidden ? 'none' : 'auto')};
  transition: opacity 0.2s ease-in-out;
  ${vw('height', 175)}
  overflow-y: scroll;

  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.color.black};
  border-top: none;
  z-index: 1;

  p {
    color: ${(props) => props.theme.color.black};
    font-weight: 500;
  }
`;

const Wrapper = styled.div`
  padding: 10px 20px;
  border-bottom: 1px solid ${(props) => props.theme.color.black};

  &:hover {
    background-color: ${(props) => props.theme.color.lightGrey};
  }
`;
